'use client';

import { forwardRef } from 'react';
import { faHeart } from '@fortawesome/pro-light-svg-icons';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons';
import { tv } from 'tailwind-variants';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Tooltip } from '@/components/ui/tooltip.component';

const shareButtonContainer = tv({
  slots: {
    container: ['w-full flex flex-col items-center text-center'],
  },
});

export interface ButtonAddToFavoritesProps extends React.HTMLAttributes<HTMLDivElement> {
  favorite: boolean;
  handleAddToFavorites: () => void;
  disabled?: boolean;
}

export const ButtonAddToFavorites = forwardRef<HTMLDivElement, ButtonAddToFavoritesProps>(
  ({ favorite, handleAddToFavorites, disabled, className, ...rest }, ref) => {
    const { container } = shareButtonContainer();

    return (
      <div ref={ref} className={container({ className })} {...rest}>
        <Tooltip message={`${favorite ? 'Remover dos' : 'Adicionar aos'} favoritos`}>
          <Button
            variant="secondary"
            onClick={handleAddToFavorites}
            className="rounded-full w-[3.75rem] h-[3.75rem] md:rounded-lg md:w-12 md:h-12 xl:w-full xl:h-fit"
            disabled={disabled}
          >
            <Icon icon={favorite ? faHeartSolid : faHeart} className="text-xl" />

            <span className="hidden xl:block text-green-500 font-semibold ld text-lg">
              {favorite ? 'Adicionado' : 'Adicionar'}
              {' '}
              aos favoritos
            </span>
          </Button>
        </Tooltip>
        <span className="text-green-400 text-center md:hidden mt-2">
          {favorite ? 'Adicionado' : 'Adicionar'}
          <br />
          {' '}
          aos favoritos
        </span>
      </div>
    );
  },
);

ButtonAddToFavorites.displayName = 'ButtonAddToFavorites';
